import { render } from "./CogsKpi.vue?vue&type=template&id=ec375ad6"
import script from "./CogsKpi.vue?vue&type=script&lang=js"
export * from "./CogsKpi.vue?vue&type=script&lang=js"

import "./CogsKpi.vue?vue&type=style&index=0&id=ec375ad6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__